import { ApiStatusError } from '../errors/ApiStatusError';

/** Whether `err` is an `ApiStatusError`, optionally with the given status. */
export function isApiStatusError(err: unknown, status?: number): err is ApiStatusError {
    return err instanceof ApiStatusError && (status === undefined || err.status === status);
}
